import React from 'react';
import { Spin, Button } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { PackageCard } from 'components/warehouse';
import { useInboundPackages } from './useInboundPackages';
import type { InboundFilters } from 'models/Warehouse';
import styles from './styles.module.scss';

interface InboundPackagesProps {
  searchValue?: string;
  filters?: InboundFilters;
}

export const InboundPackages: React.FC<InboundPackagesProps> = ({ searchValue = '', filters = {} }) => {
  const { allPackages, isLoading, page, hasMore, loadMore, handleCardClick, handleUploadDeliveryNote } =
    useInboundPackages({
      searchValue,
      filters,
    });

  if (isLoading && page === 1) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingContainer}>
          <Spin size="large" />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div id="scrollableDiv" className={styles.scrollContainer}>
        <InfiniteScroll
          dataLength={allPackages.length}
          next={loadMore}
          hasMore={hasMore}
          loader={
            <div className={styles.loadingMore}>
              <Spin />
            </div>
          }
          scrollableTarget="scrollableDiv"
        >
          <div className={styles.packageList}>
            {allPackages.map((pkg) => (
              <PackageCard key={pkg.id} package={pkg} onClick={() => handleCardClick(pkg.id)} type="inbound" />
            ))}
          </div>
        </InfiniteScroll>
      </div>
      <div className={styles.bottomAction}>
        <Button type="primary" size="large" onClick={handleUploadDeliveryNote} className={styles.uploadButton} block>
          Upload Delivery Note
        </Button>
      </div>
    </div>
  );
};
